import { render } from "./AttrSheet.vue?vue&type=template&id=3006f0e7"
import script from "./AttrSheet.vue?vue&type=script&lang=js"
export * from "./AttrSheet.vue?vue&type=script&lang=js"

import "./AttrSheet.vue?vue&type=style&index=0&id=3006f0e7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrSheet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3006f0e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3006f0e7', __exports__)) {
    api.reload('3006f0e7', __exports__)
  }
  
  module.hot.accept("./AttrSheet.vue?vue&type=template&id=3006f0e7", () => {
    api.rerender('3006f0e7', render)
  })

}


export default __exports__